import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, getImagesUrl, failedResponse } from "../common";
import { SchoolInfo } from "./schoolSlice";
import { getToken } from "../../features/user/UserAvatar";

export interface schoolInsUpdState {
  state: LoadStateInfo;
  school: SchoolInfo;
}

const initialState: schoolInsUpdState = {
  state: notStarted(),
  school: emptySchool(),
};

function emptySchool() {
  return {
    id: "",
    name: "",
    url: `${getImagesUrl()}/default/school.webp`,
  };
}

export interface SchoolInsertRequest {
  school: SchoolInfo;
}
export const schoolInsert = createAsyncThunk(
  "schoolInsert",
  async (param: SchoolInsertRequest, thunkAPI) => {
    console.debug("insert school");

    const response = await fetch(`${getBackendUrl()}/api/school`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.school)
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface SchoolDeleteRequest {
  schoolId: string;
}
export const schoolDelete = createAsyncThunk(
  "schoolDelete",
  async (param: SchoolDeleteRequest, thunkAPI) => {
    console.debug("delete classroom");

    const response = await fetch(`${getBackendUrl()}/api/school/${param.schoolId}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      }
    });

    if(response.ok) {
      return { schoolId: param.schoolId };
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface SchoolUpdateRequest {
  schoolId: string;
  school: SchoolInfo;
}
export const schoolUpdate = createAsyncThunk(
  "schoolUpdate",
  async (param: SchoolUpdateRequest, thunkAPI) => {
    console.debug("update classroom");

    const response = await fetch(`${getBackendUrl()}/api/school/${param.schoolId}`, {
      method: "PUT",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.school)
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const schoolInsUpdSlice = createSlice({
  name: "schoolInsUpd",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<SchoolInfo>) => {
      state.state = notStarted();
      state.school = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.school = emptySchool();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(schoolInsert.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(schoolInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.school = action.payload;
      })
      .addCase(schoolInsert.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(schoolUpdate.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(schoolUpdate.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.school = action.payload;
      })
      .addCase(schoolUpdate.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(schoolDelete.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(schoolDelete.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.school = emptySchool();
      })
      .addCase(schoolDelete.rejected, (state, action) => {
        state.state = error(action);
      })
      ;
    },
});

// export const { } = schoolInsUpdSlice.actions;

export const selectSchoolInsUpd = (state: RootState) => state.schoolInsUpd;

export default schoolInsUpdSlice.reducer;
